import { isAuthenticated } from "../../../commons/Auth/auth";
import { hasPermission } from "../../../commons/Permissions/PermissionsHook";

/**
 * Whether the signed-in user may open the site diary: the provider, or an employee whose role
 * may write ("Site-diary" Create) or read it. The server checks again; this only decides
 * whether to show the entry points (the project page's tab).
 */
export const canUseSiteDiary = () => {
  const user = isAuthenticated();
  if (![1, 2].includes(Number(user?.role))) return false;
  const permissions = user?.roleId?.permissions;
  return (
    hasPermission(permissions, "Site-diary", "Read") ||
    hasPermission(permissions, "Site-diary", "Create")
  );
};
